
import { Component, Mixins, ActionButtonConfig, FormModalMixins,appConst } from "@/lib";
import Role from "@/store/modules/system/customer/entity";
@Component
export default class EditCustomer extends Mixins(FormModalMixins) {
  model = new Role();
   created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit", labelWidth: 200, okAction: "system/customer/update" });
     this.$store.dispatch("system/customer/getBusinessGroupList");
  }
  
  get record() {
    return this.$store.state.system.customer.editCustomer;
  }
  get customerBusinessGroupList(){
    return this.$store.state.system.customer.businessGroupList;

  }
      get paymentList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.payment)
  }
  formValidateRule(data){
     const messageError = "超过系统支持业务组上限";
    if(data==undefined){
      return;
    }
    else{
     let q=data.toString();
     
     return[{validator: (rule:any, value:any, callback:any) => {
     if(q.length>200){
       callback(messageError);
     }
     else{
       callback();
     }
     }}];
    }
  }
}
